<template>
  <div class="SuggestionBox">
    <el-form class="custom-formScreen" inline :model="formScreen" ref="formScreen" label-width="4.8vw">
      <template v-if="isBossOperate">
        <el-form-item label="分公司" prop="branchCompanyId">
          <el-select v-model="formScreen.branchCompanyId" @change="selectChange">
            <el-option v-for="item in listBranch" :key="item.id" :label="item.companyFullName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子公司" prop="companyId">
          <el-select v-model="formScreen.companyId">
            <el-option v-for="item in listSon" :key="item.id" :label="item.companyFullName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="formScreen.status">
            <el-option v-for="(val, key) in listStatus" :key="key" :label="val.label" :value="key"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="开始时间" prop="startTimeString">
        <el-date-picker
            v-model="formScreen.startTimeString"
            type="datetime"
            placeholder="选择日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTimeString">
        <el-date-picker
            v-model="formScreen.endTimeString"
            type="datetime"
            placeholder="选择日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label=" " prop="searchString" style="width: 40%;">
        <el-input v-model="formScreen.searchString" placeholder="标题、建议回复、提交人"
                  style="width: calc(100% - 140px);margin-right: 10px;"></el-input>
        <el-button type="primary" @click="searchForm">搜索</el-button>
        <el-button type="primary" @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>

    <el-button type="primary" style="margin-bottom: 10px;" @click="increaseSuggestion" v-if="!isBossOperate">提交建议
    </el-button>

    <el-table :data="listTable" border :header-cell-style="{ textAlign: 'center' }">
      <el-table-column prop="suggestTitle" label="标题" align="center"></el-table-column>
      <el-table-column prop="suggestReply" label="建议回复" align="center"></el-table-column>
      <el-table-column prop="" label="状态" align="center">
        <template slot-scope="scope">
          <div :style="{ color: listStatus[scope.row.useStatus].color }">
            {{ listStatus[scope.row.useStatus].label }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
      <el-table-column prop="roleName" label="提交人" align="center" v-if="isBossOperate"></el-table-column>
      <el-table-column prop="" label="提交公司" align="center" v-if="isBossOperate">
        <template slot-scope="scope">
          <el-row type="flex" justify="center">
            <div v-if="scope.row.branchCompanyName">{{ `${scope.row.branchCompanyName || ''}` }}</div>
            <div v-if="scope.row.branchCompanyName && scope.row.subCompanyName"> - </div>
            <div v-if="scope.row.subCompanyName">{{ `${scope.row.subCompanyName || ''}` }}</div>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-view" @click="updateSuggestion(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </el-row>

    <el-dialog title="提交建议" width="600px" :visible.sync="dialogIncreaseVisible">
      <el-form ref="dialogIncreaseForm" :model="dialogIncreaseForm" label-width="80px" :rules="dialogIncreaseFormRules">
        <el-form-item label="标题：" prop="suggestTitle">
          <el-input v-model="dialogIncreaseForm.suggestTitle" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="suggestContest">
          <el-input type="textarea" :rows="6" v-model="dialogIncreaseForm.suggestContest"
                    placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitIncreaseSuggestion">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提交建议" width="600px" top="4vh" :visible.sync="dialogUpdateVisible">
      <el-form ref="dialogIncreaseForm" :model="dialogIncreaseForm" label-width="100px"
               :rules="dialogIncreaseFormRules">
        <el-form-item label="标题：">
          <div>{{ dialogUpdateForm.suggestTitle }}</div>
        </el-form-item>
        <el-form-item label="内容：">
          <div>{{ dialogUpdateForm.suggestContest }}</div>
        </el-form-item>
        <el-form-item label="建议回复：" v-if="dialogUpdateForm.useStatus === 0 && isBossOperate">
          <el-input type="textarea" :rows="6" v-model="dialogUpdateForm.suggestReply" placeholder="请输入回复"></el-input>
        </el-form-item>
        <el-form-item label="建议回复：" v-else-if="dialogUpdateForm.useStatus === 1">
          <div>{{ dialogUpdateForm.suggestReply }}</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <template v-if="dialogUpdateForm.useStatus === 0">
          <el-button type="primary" @click="submitUpdateSuggestion" v-if="isBossOperate">提交</el-button>
          <el-button type="danger" @click="submitDeleteSuggestion" v-else>撤销提交</el-button>
        </template>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api';

export default {
  name: "SuggestionBox",
  data() {
    return {
      UserInfo: JSON.parse(localStorage.getItem("role")),
      page: 1,
      size: 20,
      total: 0,
      formScreen: {
        branchCompanyId: '',
        companyId: '',
        status: '',
        startTimeString: '',
        endTimeString: '',
        searchString: '',
      },
      listBranch: [],
      listSon: [],
      listStatus: {
        0: { color: 'red', label: '未采纳' },
        1: { color: 'green', label: '已采纳' },
      },
      listTable: [],
      loadingTable: false,
      dialogIncreaseVisible: false,
      dialogIncreaseForm: {},
      dialogIncreaseFormRules: {
        suggestTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        suggestContest: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      dialogUpdateVisible: false,
      dialogUpdateForm: {},
    }
  },
  created() {
    this.getBranchCompanyList()
    this.getListTable()
  },
  computed: {
    isBossOperate() {
      return this.UserInfo.type === 1 && this.UserInfo.system === 1
    },
  },
  methods: {
    searchForm() {
      this.page = 1
      this.getListTable()
    },
    resetForm() {
      this.page = 1
      this.listSon = []
      this.$refs.formScreen.resetFields()
      this.searchForm()
    },
    selectChange(id) {
      this.formScreen.companyId = ''
      this.getSonCompanyList(id);
    },
    getBranchCompanyList() {
      const API = Baseurl + "logisticsController/getAllBranchCompany";
      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listBranch = data;
        }
      });
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listSon = data;
        }
      });
    },
    handleSizeChange(val) {
      this.size = val
      this.getListTable()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getListTable()
    },
    getListTable() {
      const API = Baseurl + 'suggestBoxController/selectSuggestBoxList'
      const paramsData = {
        page: this.page,
        size: this.size,
        ...this.formScreen,
      }
      if (!this.isBossOperate) {
        paramsData.submitRoleId = this.UserInfo.rid
      }
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    increaseSuggestion() {
      this.dialogIncreaseForm = {
        suggestTitle: '',
        suggestContest: '',
      }
      this.dialogIncreaseVisible = true
    },
    submitIncreaseSuggestion() {
      this.$refs.dialogIncreaseForm.validate((valid) => {
        if (!valid) return
        const API = Baseurl + 'suggestBoxController/insertSuggestBox'
        const paramsData = {
          companyId: this.UserInfo.company_id,
          submitRoleId: this.UserInfo.rid,
          ...this.dialogIncreaseForm,
        }
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            this.dialogIncreaseVisible = false
            this.getListTable()
            this.$message.success('操作成功')
          } else {
            this.$message.error(data)
          }
        })
      })
    },
    updateSuggestion(row) {
      this.dialogUpdateForm = JSON.parse(JSON.stringify(row))
      this.dialogUpdateVisible = true
    },
    submitUpdateSuggestion() {
      if (!this.dialogUpdateForm.suggestReply) {
        this.$message.warning('请输入建议回复')
        return
      }
      const API = Baseurl + 'suggestBoxController/updateStatusById'
      const paramsData = {
        useRoleId: this.UserInfo.rid,
        id: this.dialogUpdateForm.id,
        useStatus: 1,
        suggestReply: this.dialogUpdateForm.suggestReply,
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.dialogUpdateVisible = false
          this.getListTable()
          this.$message.success('操作成功')
        } else {
          this.$message.error(data)
        }
      })
    },
    submitDeleteSuggestion() {
      this.$confirm('您确定要撤销此建议吗？', '提示')
          .then(() => {
            const API = Baseurl + 'suggestBoxController/updateStatusById'
            const paramsData = {
              id: this.dialogUpdateForm.id,
              submitStatus: 0,
            }
            ajaxPost(API, paramsData).then(res => {
              const { code, data } = res.data
              if (code === 200) {
                this.dialogUpdateVisible = false
                this.getListTable()
                this.$message.success('操作成功')
              } else {
                this.$message.error(data)
              }
            })
          })
    },
  },
}
</script>

<style lang="scss" scoped>
.SuggestionBox {
  width: 98%;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>